import React, { useContext, useEffect, useState } from 'react';
import HTMLReactParser from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import './privacypolicy.css';
import MetricsContext from '../../context/MetricsContext';
import PageNames from '../../utils/PageNames';
import PageTypes from '../../utils/PageTypes';
import BaseLayout from '../../commons/BaseLayout';

function PrivacyPolicy() {
  const { t } = useTranslation();
  const { updateUserMetric } = useContext(MetricsContext);
  const VERSION_STORAGE_KEY = '@kitoApp/version';
  const [, setActiveVersion] = useState(() => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');

  const sessionId = localStorage.getItem('sessionId');
  useEffect(() => {
    updateUserMetric({
      name: PageNames.POLICY_PAGE,
      pageType: PageTypes.DEFAULT,
    });
  }, [sessionId]);
  return (
    <BaseLayout goBack header headerLogo onVersionChange={setActiveVersion} sidebar>
      <div className="privacyBody">{HTMLReactParser(t('legal.privacy.body'))}</div>
    </BaseLayout>
  );
}

export default PrivacyPolicy;
